import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import {FOOTER_ACTION_SET, FooterActionRemove} from "@store/actions";
import 'rxjs/add/operator/map';

@Injectable()
export class FooterEffects {

  constructor(
    private actions: Actions,
  ) {}

  @Effect()
  setFooterAction: Observable<any> = this.actions.ofType<any>(FOOTER_ACTION_SET)
    .delay(500)
    .map(() => new FooterActionRemove());
}



// WEBPACK FOOTER //
// ./src/app/store/effects/footer.effect.ts